import { stateLabel, kindLabel } from './display-copy';
import { displayValue } from '../../lib/oem-display';
import type { OemRecord } from '../../lib/oem-client';
export interface FieldContract {
  type?: string;
  properties?: Record<string, FieldContract>;
  items?: FieldContract;
  enum?: unknown[];
  const?: unknown;
  anyOf?: FieldContract[];
  format?: string;
  pattern?: string;
  maxLength?: number;
  minimum?: number;
  maximum?: number;
  required?: string[];
}
const labels: Record<string, string> = {
  label: 'ชื่อ / รหัส',
  summary: 'รายละเอียดและสิ่งที่ยังไม่ทราบ',
  source: 'แหล่งหลักฐาน',
  revisionReason: 'เหตุผลการแก้ไข',
  nextAction: 'งานถัดไป',
  dueAt: 'กำหนดส่ง',
  basis: 'ฐานคำนวณ',
  lines: 'รายการ',
  materialId: 'วัตถุดิบ',
  supplierSpecId: 'สเปกผู้ขายฉบับที่เลือก',
  constituents: 'ส่วนประกอบวัตถุดิบผสม',
  ingredientId: 'ส่วนประกอบ INCI',
  concentration: 'ความเข้มข้น (%)',
  amount: 'จำนวน / มูลค่า',
  unit: 'หน่วย',
  state: 'สถานะหลักฐาน',
  steps: 'ขั้นตอน',
  phase: 'เฟส',
  instruction: 'วิธีปฏิบัติ',
  equipment: 'อุปกรณ์',
  method: 'วิธี',
  conditions: 'เงื่อนไข',
  formulaId: 'สูตรฉบับที่เลือก',
  processId: 'กระบวนการฉบับที่เลือก',
  densityId: 'ค่าความหนาแน่นที่ตรวจแล้ว',
  usableYield: 'อัตราผลผลิตที่ใช้ได้ (0–1)',
  ipSource: 'หลักฐานสิทธิ์สูตร',
  permittedUse: 'ขอบเขตสิทธิ์ใช้',
  criteria: 'เกณฑ์',
  threshold: 'ค่าเกณฑ์',
  tolerance: 'ค่าคลาดเคลื่อน',
  quantity: 'จำนวน',
  sampleRequestId: 'คำขอตัวอย่าง',
  preparationId: 'การเตรียมจริง',
  preparationCode: 'รหัสเตรียม',
  sampleCode: 'รหัสตัวอย่างจริง',
  custodian: 'ผู้เก็บรักษา',
  retainedReference: 'ตัวอย่างเก็บอ้างอิง',
  componentId: 'ชิ้นส่วนฉบับที่เลือก',
  componentIds: 'ส่วนประกอบชุดบรรจุภัณฑ์',
  packagingId: 'บรรจุภัณฑ์ฉบับที่เลือก',
  fileId: 'ไฟล์หลักฐาน',
  reportId: 'รายงานผล',
  fileStage: 'ระยะไฟล์',
  dielineId: 'ไฟล์แบบตัดฉบับที่เลือก',
  drawingId: 'ไฟล์แบบชิ้นส่วนฉบับที่เลือก',
  proofPage: 'หน้าแบบ',
  market: 'ตลาด',
  language: 'ภาษา',
  capacity: 'ความจุที่ระบุ',
  fillSize: 'ขนาดบรรจุ',
  dimensions: 'ขนาด / หน่วย / ค่าคลาดเคลื่อน',
  material: 'วัสดุ',
  finish: 'สีและผิว',
  rightsSource: 'หลักฐานสิทธิ์',
  compatibilitySource: 'หลักฐานความเข้ากันได้',
  capacityState: 'สถานะกำลังการผลิต',
  capacitySource: 'หลักฐานกำลังการผลิต',
  batchBasis: 'ขนาดชุดผลิต',
  fillingSource: 'หลักฐานการบรรจุ',
  cleaningSource: 'หลักฐานการทำความสะอาด',
  yieldSource: 'หลักฐานอัตราผลผลิต',
  roundingPolicy: 'นโยบายปัดค่า',
  targetIds: 'เวอร์ชันที่เกี่ยวข้อง',
  references: 'รายการฉบับที่เลือก',
  targetId: 'รายการที่เลือกตรวจ',
  policyId: 'นโยบายฉบับที่เลือก',
  tests: 'การทดสอบ / ค่าใช้จ่าย',
  planId: 'แผนทดสอบฉบับที่เลือก',
  required: 'จำเป็น',
  rationale: 'เหตุผลและข้อจำกัด',
  artworkRequired: 'ต้องมีแบบฉลาก',
  depositRequired: 'ต้องมีมัดจำ',
  depositAmount: 'มูลค่ามัดจำ',
  lab: 'ห้องปฏิบัติการ',
  result: 'ผล',
  value: 'ค่า',
  disposition: 'การจัดประเภทผล',
  quoteType: 'ประเภทใบเสนอราคา',
  costId: 'ต้นทุนฉบับที่เลือก',
  terms: 'เงื่อนไข',
  validUntil: 'ใช้ได้ถึง',
  destination: 'ปลายทาง',
  currency: 'สกุลเงิน',
  tax: 'ภาษี',
  unitPrice: 'ราคาต่อหน่วย',
  skuId: 'SKU',
  specId: 'สเปกฉบับที่เลือก',
  policyType: 'ประเภทนโยบาย',
  fee: 'ค่ารอบตัวอย่าง',
  includedRounds: 'จำนวนรอบรวม',
  extraRoundCharge: 'ค่ารอบเพิ่ม',
  shippingTerms: 'เงื่อนไขจัดส่ง',
  orderCreditTerms: 'เงื่อนไขเครดิตเมื่อสั่ง',
  approvedSource: 'หลักฐานเจ้าของนโยบาย',
  lossBasis: 'Allowance basis',
  loss: 'Allowance fraction (0–1)',
  inputs: 'รายการต้นทุน',
  unitCost: 'ต้นทุนต่อหน่วย',
  labor: 'ค่าแรง',
  development: 'ค่าพัฒนา',
  setup: 'ค่า setup',
  tooling: 'ค่า tooling',
  logistics: 'ค่า logistics',
  fx: 'อัตราแลกเปลี่ยน',
  engineVersion: 'รุ่นเครื่องคำนวณ',
  rawTotal: 'ค่าก่อนปัด',
  roundedTotal: 'ค่าหลังปัด',
  margin: 'Margin',
  markup: 'Markup',
  timing: 'เวลาและเงื่อนไข',
  ownership: 'เจ้าของกรรมสิทธิ์',
  surplus: 'ความเสี่ยงของเหลือ',
  cancellationExposure: 'ความเสี่ยงยกเลิก',
  costCap: 'วงเงิน',
  artworkId: 'Artwork exact version',
  paymentStatus: 'หลักฐานการชำระ',
  bankReference: 'อ้างอิงธนาคาร',
  receivedAt: 'เวลารับ',
  audience: 'กลุ่มผู้เห็น',
  severity: 'ระดับ hold',
  resolutionSource: 'หลักฐานแก้ hold',
  sourceHash: 'SHA-256 ต้นฉบับ',
  sourceVersion: 'เวอร์ชันต้นฉบับ',
  rows: 'แถวข้อมูล',
  factIds: 'ข้อเท็จจริงที่อ้าง',
  sections: 'ส่วนเอกสาร',
  heading: 'หัวข้อ',
  body: 'เนื้อหา',
  illustrative: 'ภาพประกอบ',
  status: 'สถานะที่แจ้ง',
  grade: 'เกรด',
  identity: 'ตัวตนใน registry',
  inci: 'INCI',
  code: 'รหัสเกณฑ์',
};
export function ContractField({
  name,
  schema,
  value,
  onChange,
  records,
  skus = [],
  required = false,
  labelOverride,
}: {
  readonly name: string;
  readonly schema: FieldContract;
  readonly value: unknown;
  readonly onChange: (v: unknown) => void;
  readonly records: OemRecord[];
  readonly skus?: readonly {
    id: string;
    label: string;
  }[];
  readonly required?: boolean;
  readonly labelOverride?: string | undefined;
}) {
  const s = schema.anyOf?.find((x) => x.type !== 'null') ?? schema;
  const label = labelOverride ?? labels[name] ?? name;
  if (s.type === 'object') {
    const object = (value ?? {}) as Record<string, unknown>;
    return (
      <fieldset className="contract-group">
        <legend>{label}</legend>
        {Object.entries(s.properties ?? {}).map(([k, child]) => (
          <ContractField
            key={k}
            name={k}
            schema={child}
            value={object[k]}
            required={s.required?.includes(k) ?? false}
            records={records}
            skus={skus}
            onChange={(v) => onChange({ ...object, [k]: v })}
          />
        ))}
      </fieldset>
    );
  }
  if (s.type === 'array') {
    const rows: unknown[] = Array.isArray(value) ? (value as unknown[]) : [];
    return (
      <fieldset className="contract-group">
        <legend>{label}</legend>
        {rows.map((r, i) => (
          <div key={i} className="contract-row">
            <ContractField
              name={name === 'lines' ? 'รายการ' : name}
              labelOverride={labelOverride}
              schema={s.items ?? { type: 'string' }}
              value={r}
              records={records}
              skus={skus}
              onChange={(v) => onChange(rows.map((x, n) => (n === i ? v : x)))}
            />
            <button
              type="button"
              className="action secondary"
              onClick={() => onChange(rows.filter((_, n) => n !== i))}
            >
              ลบรายการร่าง {i + 1}
            </button>
          </div>
        ))}
        <button
          type="button"
          className="action secondary"
          onClick={() => onChange([...rows, s.items?.type === 'object' ? {} : ''])}
        >
          เพิ่ม {label}
        </button>
      </fieldset>
    );
  }
  if (s.type === 'boolean')
    return (
      <label>
        {label}
        <select
          value={value === undefined ? '' : displayValue(value)}
          onChange={(e) => onChange(e.target.value === '' ? undefined : e.target.value === 'true')}
          required={required}
        >
          <option value="">ยังไม่ระบุ</option>
          <option value="true">ใช่</option>
          <option value="false">ไม่ใช่</option>
        </select>
      </label>
    );
  if (s.enum || s.const !== undefined)
    return (
      <label>
        {label}
        <select
          value={displayValue(value ?? '')}
          required={required}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">ยังไม่ระบุ</option>
          {(s.enum ?? [s.const]).map((o) => (
            <option key={displayValue(o)} value={displayValue(o)}>
              {stateLabel(displayValue(o))}
            </option>
          ))}
        </select>
      </label>
    );
  if (s.format === 'uuid')
    return (
      <label>
        {label}
        <input
          value={displayValue(value ?? '')}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          list={`records-${name}`}
        />
        <datalist id={`records-${name}`}>
          {name === 'skuId'
            ? skus.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.label}
                </option>
              ))
            : null}
          {records.map((r) => (
            <option key={r.id} value={r.id}>
              {displayValue(r.content.label)} · {kindLabel(r.kind)} v{r.version}
            </option>
          ))}
        </datalist>
      </label>
    );
  return (
    <label>
      {label}
      {[
        'summary',
        'source',
        'rationale',
        'body',
        'comment',
        'instruction',
        'revisionReason',
      ].includes(name) ||
      (name === 'requestedServices' && labelOverride !== undefined) ? (
        <textarea
          value={displayValue(value ?? '')}
          required={required}
          maxLength={s.maxLength}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <input
          value={displayValue(value ?? '')}
          required={required}
          inputMode={
            s.type === 'number' || s.type === 'integer' || s.pattern?.includes('[0-9]')
              ? 'decimal'
              : 'text'
          }
          onChange={(e) =>
            onChange(
              s.type === 'integer' || s.type === 'number'
                ? e.target.value === ''
                  ? undefined
                  : Number(e.target.value)
                : e.target.value,
            )
          }
        />
      )}
    </label>
  );
}
